<app-verify-trip-sheet
  [isDeliveryManagerMode]="false"
  [tripSheet]="tripSheet"
  [tripSheetDetailMode]="tripSheetDetailModes"
  [dialogMode]="dialogMode"
></app-verify-trip-sheet>
